import { render, staticRenderFns } from "./projectintroduction.vue?vue&type=template&id=bdc9a606&scoped=true&"
import script from "./projectintroduction.vue?vue&type=script&lang=js&"
export * from "./projectintroduction.vue?vue&type=script&lang=js&"
import style0 from "./projectintroduction.vue?vue&type=style&index=0&id=bdc9a606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc9a606",
  null
  
)

export default component.exports